import { render, staticRenderFns } from "./HealthXueYaChart.vue?vue&type=template&id=4fae91bb&scoped=true"
import script from "./HealthXueYaChart.vue?vue&type=script&lang=js"
export * from "./HealthXueYaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae91bb",
  null
  
)

export default component.exports